import { StyleSheet } from 'react-native';

/** Shared styles for filter screen/modal (activity and asset). */
export const filterScreenStyles = StyleSheet.create({
  scrollContentPage: { paddingBottom: 120 },
  scrollContentModal: { paddingBottom: 120 },
  viewResultsButton: { flex: 1, height: 56, maxHeight: 56 },
  viewResultsButtonWithMargin: { marginRight: 16 },
});
